import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import './styles/App.scss';

export const iLog = function(params: string, extra: any) {
    if ( process.env.REACT_APP_ENV === 'local' ) { console.log(params, extra) }
}

Sentry.init({
	dsn: "https://cb08f6907bc26e76960475d0742e88d1@o4511387715829760.ingest.de.sentry.io/4511387883077712",
	release: process.env.REACT_APP_SENTRY_RELEASE,
	environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'local',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true
});

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
